import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "621.823",
  x2: "100",
  y2: "748.86",
  gradientTransform: "translate(0 -567)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m166.9 72.8 19.7 17.8c4.2 3.8 4.5 10.2.6 14.3-2 2.2-4.8 3.3-7.6 3.3-2.6 0-5.1-1-7.1-2.7l-63.6-57.4c-5.3-4.8-13.6-4.8-18.9.1l-62.5 57.1c-4.2 3.8-10.8 3.6-14.7-.4-3.9-4.1-3.7-10.5.5-14.3L88 22.2c5-4.7 15.7-5.9 21.4-1.2l36.7 33V40c0-5.8 4.7-10.5 10.4-10.5 5.8 0 10.4 4.7 10.4 10.5v32.8zM92.7 57.4c3.9-3.4 10-3.4 13.9 0l60.5 56.1v59c0 5.2-4.6 9.4-10.2 9.4H42.3c-5.6 0-10.2-4.2-10.2-9.4v-58.7l60.6-56.4z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}